import axios from "axios"

export const postEvent = (
  space: { spaceName?: string; shareToken?: string } | null,
  type: string,
  additionalParams: Record<string, unknown> = {},
) => {
  const { spaceName, shareToken } = space || {}
  axios.post("/api/events", {
    event: {
      type: type,
      space_name: spaceName,
      share_token: shareToken,
      ...additionalParams,
    },
  })
}
